var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAreas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,23.7l-0.6-0.4C3,17.2,3,10,3,9.6c0-5,4-9,9-9c5,0,9,4,9,9c0,0.3,0.1,7.6-8.4,13.7L12,23.7z M5,9.6c0,0.3,0,6.3,7,11.6 c7-5.3,7-11.3,7-11.6c0-3.9-3.1-7-7-7C8.1,2.6,5,5.7,5,9.6L5,9.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,12.9c-1.8,0-3.4-1.5-3.4-3.4s1.5-3.4,3.4-3.4c1.8,0,3.4,1.5,3.4,3.4S13.8,12.9,12,12.9z M12,8.2 c-0.7,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4S12.7,8.2,12,8.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAreas);
export default __webpack_public_path__ + "static/media/icon-areas.8b68ba4a2849a269f0bfe491d14587f4.svg";
export { ForwardRef as ReactComponent };